/**
 * Stable Global Search facade for UI. Swappable transport (fan-out today, unified API later).
 */

import { getEnabledSearchProviders } from './registry';
import type {
  EntitySearchTransport,
  GlobalSearchSectionMeta,
  GlobalSearchSectionResult,
} from './types';

export type GlobalSearchClientSearchInput = {
  query: string;
  limit: number;
  signal?: AbortSignal;
  hasPermission: (permission: string) => boolean;
};

export class GlobalSearchClient {
  private transport: EntitySearchTransport;

  constructor(transport: EntitySearchTransport) {
    this.transport = transport;
  }

  setTransport(transport: EntitySearchTransport): void {
    this.transport = transport;
  }

  getEnabledSections(
    hasPermission: (permission: string) => boolean,
  ): GlobalSearchSectionMeta[] {
    return getEnabledSearchProviders(hasPermission).map((provider) => ({
      id: provider.id,
      titleKey: provider.titleKey,
      iconId: provider.iconId,
    }));
  }

  search(
    input: GlobalSearchClientSearchInput,
  ): Promise<GlobalSearchSectionResult[]> {
    return this.transport.search(input);
  }
}
